export class FullAddressModel {
    displayName: string = '';
    address: string = '';
    fullAddress: string = '';
    postalCode: string = '';
    city: string = '';
    jurisdiction: string = '';
    jurisdictionCode: string = '';
    country: string = '';
    countryCode: string = '';
}
